var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0001C0 5.37261 5.37259 0 12 0C18.6274 0 24 5.37261 24 12.0001C24 18.6275 18.6274 24.0001 12 24.0001C5.37259 24.0001 0 18.6275 0 12.0001ZM12 1.78885C6.36055 1.78885 1.78885 6.36057 1.78885 12.0001C1.78885 14.609 2.76728 16.9895 4.37724 18.7943C6.07561 16.4209 8.85675 14.8718 12.0007 14.8718C15.1443 14.8718 17.9251 16.4205 19.6235 18.7936C21.2331 16.9887 22.2112 14.6086 22.2112 12.0001C22.2112 6.36057 17.6394 1.78885 12 1.78885ZM18.3056 20.0322C16.9453 17.9978 14.6286 16.6607 12.0007 16.6607C9.37248 16.6607 7.05558 17.9982 5.69526 20.033C7.43133 21.3974 9.62064 22.2112 12 22.2112C14.3798 22.2112 16.5695 21.3972 18.3056 20.0322ZM7.5752 10.1265C7.5752 7.68259 9.55636 5.70142 12.0002 5.70142C14.4441 5.70142 16.4253 7.68259 16.4253 10.1265C16.4253 12.5704 14.4441 14.5515 12.0002 14.5515C9.55636 14.5515 7.5752 12.5704 7.5752 10.1265ZM12.0002 7.49027C10.5443 7.49027 9.36405 8.67054 9.36405 10.1265C9.36405 11.5824 10.5443 12.7627 12.0002 12.7627C13.4562 12.7627 14.6364 11.5824 14.6364 10.1265C14.6364 8.67054 13.4562 7.49027 12.0002 7.49027Z",
    fill: "#E5B80B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogImg2);
export default __webpack_public_path__ + "static/media/BlogImg2.cbba43932fa473b478dbfd20966d6860.svg";
export { ForwardRef as ReactComponent };